import type { CapacityRequest } from './model';

function CapacityTimestamp({ value }: { value: number }) {
  const date = new Date(value);
  return <time dateTime={date.toISOString()}>{date.toLocaleString('en-US', {
    year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', minute: '2-digit', second: '2-digit', timeZoneName: 'short',
  })}</time>;
}

export function CapacityResponse({ row }: { row: CapacityRequest }) {
  const response = row.lastResponse;
  if (!response) return null;
  const labels = { APPROVED: 'Approved', CANCELLED: 'Cancelled', DENIED: 'Denied', COUNTERED: 'Countered', NEEDS_INFO: 'Information requested', ACCEPT: 'Counter accepted', DECLINE: 'Counter declined' };
  return <div className="mt-1 text-xs text-muted">
    <span>{labels[response.action]} · </span><CapacityTimestamp value={response.createdAt} />
    <div>By {response.actor}</div>
  </div>;
}

export function CapacityHistory({ row }: { row: CapacityRequest }) {
  return <ol className="my-3 space-y-2">{row.events?.length ? row.events.map(event => (
    <li key={event.id} className="rounded border border-theme-border-primary bg-panel p-3 text-sm text-body">
      <div className="mb-1 flex flex-wrap justify-between gap-2 text-xs text-muted"><span>{event.actor}</span><CapacityTimestamp value={event.createdAt} /></div>
      <p className="whitespace-pre-wrap break-words">{event.message}</p>
    </li>
  )) : row.thread.map((message, index) => <li key={index} className="rounded border border-theme-border-primary bg-panel p-3 text-sm text-body">{message}</li>)}</ol>;
}
